<template>
    <div class=" flex align-center justify-end ">
        <div class="title-h2 mr-2 text-right text-nowrap" :class="{'save-error':saveState === 'error'}" v-if="saveState !== ''">
            <i class="fal fa-spinner fa-spin" v-if="saveState === 'start'"></i>
            <i class="fal fa-times" v-if="saveState === 'error'"></i>
            <span class="ml-1">{{lastSaveString}}</span>
        </div>
        <btn square @click="$emit('undo')" :disabled="!undoActive" v-if="undoRedo">
            <tooltip :text="$t('Cancel last change')" delay="0.5s">
                <i class="fal fa-undo"></i>
            </tooltip>
        </btn>
        <btn square :disabled="!redoActive" @click="$emit('redo')" v-if="undoRedo">
            <tooltip :text="$t('Restore')" delay="0.2s">
                <i class="fal fa-redo"></i>
            </tooltip>
        </btn>
        <slot/>
    </div>
</template>

<script>
import Tooltip from "@/modules/tooltip";
import Btn from "@/modules/buttons/btn";
import events from "@/events/events";
export default {
    name: "Header_Tools",
    components: {Btn, Tooltip},
    props:{
        undoActive:Boolean,
        redoActive:Boolean,
        type:String,
        undoRedo:{type:Boolean, default: true}
    },
    data() {
        return {
            lastSaveString:"No modification",
            saveState:"",
            lastSave:-1,
            lastError:"",
        }
    },
    methods:{
        intervalLastSave(){
            clearInterval(this.interval)
            this.lastSaveFn();
            this.interval = setInterval(() => {
                this.lastSaveFn();
            },15000);
        },
        lastSaveFn(){
            if(this.saveState === "success") {
                this.lastSaveString = this.$t("Last saved:") + " " + this.$moment(this.lastSave).fromNow();
            }
            if(this.saveState === "error") {
                this.lastSaveString = this.$t("Error:")+" "+this.lastError;
            }
        },
        saveStart(){
            console.log("saveStart")
            this.saveState = "start"
            this.lastSaveString = "Saving..."
        },
        saveEnd(){
            console.log("saveEnd")
            
            setTimeout(() => {
                this.saveState = "success"
                this.lastSave = new Date()
                this.lastSaveFn();
            },250)
        },
        saveError(err){
            console.log("saveError",err)
            this.saveState = "error"
            this.lastError = err;
            this.lastSaveFn();
        },
    },
    mounted() {
        this.intervalLastSave()
        events.$on(this.type+':save:start',this.saveStart);
        events.$on(this.type+':save:end',this.saveEnd);
        events.$on(this.type+':save:error',this.saveError);
    },
    destroyed() {
        clearInterval(this.interval)
    
        events.$off(this.type+':save:start',this.saveStart);
        events.$off(this.type+':save:end',this.saveEnd);
        events.$off(this.type+':save:error',this.saveError);
    },
}
</script>